import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {IngenieroAgronomoCore} from '../models';
import {ApiService} from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class IngenieroAgronomoService extends ApiService<IngenieroAgronomoCore> {
  protected dataKey = 'ingenierosAgronomos';
  protected objectKey = 'IngenierosAgronomos';
  protected sendObjectKey = 'ingenierosAgronomos';
  protected sendObjectIdsKey = 'id';

  constructor(protected httpClient: HttpClient) {
    super(IngenieroAgronomoCore, httpClient);
  }

}
